export function useProductEditingRestrictions() {
  function canProductBeEdited(productState?: string) {
    if (!productState) return true;

    return ![
      'NEED_MODERATION',
      'NEED_RETOUCH',
      'RETOUCH_DONE',
    ].includes(productState);
  }

  return {
    canProductBeEdited,
  };
}
